import { rankCol, playerCol, divCol, teamCol, confCol, yearCol, numCol, round3Col } from "./helpers";

const num = (name, field, width = "5rem") => numCol(name, field, width);
const r3 = (name, field, width = "6.5rem") => round3Col(name, field, width);

export const splitsBatterStatFieldDefs = [
  { name: "PA", field: "pa_overall", kind: "num", width: "5rem" },
  { name: "wOBA", field: "woba_overall", kind: "r3", width: "6.5rem" },
  { name: "PA vs RHP", field: "pa_vs_rhp", kind: "num", width: "7rem" },
  { name: "PA vs LHP", field: "pa_vs_lhp", kind: "num", width: "7rem" },
  { name: "BA vs RHP", field: "ba_vs_rhp", kind: "r3", width: "7rem" },
  { name: "BA vs LHP", field: "ba_vs_lhp", kind: "r3", width: "7rem" },
  { name: "wOBA vs RHP", field: "woba_vs_rhp", kind: "r3", width: "7.5rem" },
  { name: "wOBA vs LHP", field: "woba_vs_lhp", kind: "r3", width: "7.5rem" },
  { name: "OBP", field: "obp_overall", kind: "r3", width: "6.5rem" },
  { name: "SLG", field: "slg_overall", kind: "r3", width: "6.5rem" },
];

export const splitsPitcherStatFieldDefs = [
  { name: "BF", field: "pa_overall", kind: "num", width: "5rem" },
  { name: "o-wOBA", field: "woba_overall", kind: "r3", width: "7rem" },
  { name: "BF vs RHH", field: "pa_vs_rhh", kind: "num", width: "7rem" },
  { name: "BF vs LHH", field: "pa_vs_lhh", kind: "num", width: "7rem" },
  { name: "o-BA vs RHH", field: "ba_vs_rhh", kind: "r3", width: "7.5rem" },
  { name: "o-BA vs LHH", field: "ba_vs_lhh", kind: "r3", width: "7.5rem" },
  { name: "o-wOBA vs RHH", field: "woba_vs_rhh", kind: "r3", width: "8rem" },
  { name: "o-wOBA vs LHH", field: "woba_vs_lhh", kind: "r3", width: "8rem" },
  { name: "o-OBP", field: "obp_overall", kind: "r3", width: "6.5rem" },
  { name: "o-SLG", field: "slg_overall", kind: "r3", width: "6.5rem" },
];

const batterStats = splitsBatterStatFieldDefs.map((d) =>
  d.kind === "num" ? num(d.name, d.field, d.width) : r3(d.name, d.field, d.width)
);

const pitcherStats = splitsPitcherStatFieldDefs.map((d) =>
  d.kind === "num" ? num(d.name, d.field, d.width) : r3(d.name, d.field, d.width)
);

export const getSplitsBatterColumns = [
  rankCol(), playerCol(), teamCol(), confCol(), divCol(), yearCol(),
  ...batterStats,
];

export const getSplitsPitcherColumns = [
  rankCol(), playerCol(), teamCol(), confCol(), divCol(), yearCol(),
  ...pitcherStats,
];

export const getSplitsBattingTeamColumns = [
  rankCol(), teamCol(), confCol(), divCol(), yearCol(),
  ...batterStats,
];

export const getSplitsPitchingTeamColumns = [
  rankCol(), teamCol(), confCol(), divCol(), yearCol(),
  ...pitcherStats,
];

const scoutingPrintIdentity = [
  { label: "Player", field: "player_name", kind: "text" },
  { label: "Team", field: "team_name", kind: "text" },
  { label: "Conference", field: "conference", kind: "text" },
  { label: "Div", field: "division", kind: "text" },
  { label: "Year", field: "year", kind: "num" },
];

export function getSplitsScoutingPrintFields(kind) {
  const stats =
    kind === "pitcher" ? splitsPitcherStatFieldDefs : splitsBatterStatFieldDefs;
  return [
    ...scoutingPrintIdentity,
    ...stats.map((s) => ({ label: s.name, field: s.field, kind: s.kind })),
  ];
}
